import React from "react";
import Header from '../Home/Header';
import Footer from '../Home/Footer';
import AboutCustomers from "./AboutCustomers";
import AboutCustomers2 from "./AboutCustomers2";
const OurCustomers = () => {
  return (
    <>
      <Header />
      <AboutCustomers/>
      <AboutCustomers2/>
      <Footer />
    </>
  );
};

export default OurCustomers;
